import React from 'react';
import { FormattedMessage } from 'react-intl';

const DefaultNoResultsComponent = (props) => {
  return (
    <FormattedMessage
      id="No results found."
      defaultMessage="Dieser Ordner hat zur Zeit keinen Inhalt."
    />
  );
};

export default DefaultNoResultsComponent;
